module.exports = __webpack_public_path__ + "static/img/cancellation.11a6bd49.png";